import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { createOTP, validateOTP } from "../utils/requests/auth";
import { Logo } from './child/Logo';
import { setCookie } from "../utils/cookies";
import { fetchSettings } from "../utils/requests/settings";
import { useAtom } from "jotai";
import { settingsAtom } from "../utils/atoms";

const SignInLayer = () => {
  const [step, setStep] = useState(1);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [, setSettings] = useAtom(settingsAtom);

  // Step 1: Send OTP
  const handleSendOtp = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await createOTP(phoneNumber);
      setStep(2);
    } catch (e) {
      setError("Failed to send OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Step 2: Validate OTP
  const handleValidateOtp = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await validateOTP(phoneNumber, otp);
      if (!data.token) throw new Error("No token returned");
      setCookie('token', data.token, 365);
      const settings = await fetchSettings()
      setSettings(settings)
      const continueTo = searchParams.get('continue') || '/';
      navigate(continueTo, { replace: true });
    } catch (e) {
      setError("Invalid OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className='auth bg-base d-flex flex-wrap'>
      <div className='auth-left d-lg-block d-none'>
        <div className='d-flex align-items-center flex-column h-100 justify-content-center bg-primary-500'>
          <img src='assets/images/auth/auth-img.png' alt='' />
        </div>
      </div>

      <div className='auth-right py-32 px-24 d-flex flex-column justify-content-center'>
        <div className='max-w-464-px mx-auto w-100'>
          <div>
            <Logo className='mb-8 max-w-290-px d-lg-none d-block' />
            <h4 className='mb-12'>התחבר למשתמש שלך</h4>
            <p className='mb-32 text-secondary-light text-md'>ההתחברות מתבצעת באמצעות מספר הנייד שלכם</p>
          </div>
          {error && <div className='alert alert-danger'>{error}</div>}
          {step === 1 && (
            <form onSubmit={handleSendOtp}>
              <div className='icon-field mb-16'>
                <span className='icon top-50 translate-middle-y'>
                  <Icon icon='solar:phone-outline' />
                </span>
                <input
                  type='tel'
                  placeholder='מספר נייד'
                  className='form-control h-56-px bg-neutral-50 radius-12'
                  value={phoneNumber}
                  onChange={e => setPhoneNumber(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>
              <button
                type='submit'
                className='btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32'
                disabled={loading}
              >
                {loading ? 'שולח...' : 'שלח קוד חד פעמי'}
              </button>
            </form>
          )}
          {step === 2 && (
            <form onSubmit={handleValidateOtp}>
              <div className='icon-field mb-16'>
                <span className='icon top-50 translate-middle-y'>
                  <Icon icon='solar:lock-password-outline' />
                </span>
                <input
                  type='text'
                  className='form-control h-56-px bg-neutral-50 radius-12'
                  placeholder='הקוד שקיבלת ב-SMS'
                  value={otp}
                  onChange={e => setOtp(e.target.value)}
                  maxLength={6}
                  required
                  disabled={loading}
                />
              </div>
              <button
                type='submit'
                className='btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32'
                disabled={loading}
              >
                {loading ? 'מאמת...' : 'אמת קוד'}
              </button>
              <button
                type='button'
                className='btn btn-link mt-16'
                onClick={() => setStep(1)}
                disabled={loading}
              >
                התחבר באמצעות מספר אחר
              </button>
            </form>
          )}

        </div>
      </div>
    </section>
  );
};

export default SignInLayer;
